<script lang="ts">
	import type { NumberRange, SearchFieldProps } from 'utility/search-fields'

	import Pin from './Pin.svelte'
	import YearInput from '@isoftdata/svelte-year-input'
	import EditModeControls from './EditModeControls.svelte'

	interface Props extends SearchFieldProps<NumberRange> {
		id: string
		label?: string
		value?: NumberRange
	}

	let {
		id,
		label = '',
		inEditMode,
		searchField,
		disabled = false,
		value = $bindable({ from: null, to: null }),
		pinnedSearchFields,
		selectedSearchFieldsKeys,
		change,
	}: Props = $props()
</script>

<EditModeControls
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
	{searchField}
	{inEditMode}
>
	<label
		for={id}
		class="col-form-label pb-0"
		>{label}
		<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
	</label>
	<div class="form-row">
		<div class="col-12 col-md-6">
			<YearInput
				{id}
				label="From"
				disabled={disabled || inEditMode}
				value={value.from}
				change={newVal => {
					value.from = newVal
					change?.({ field: searchField, value: { from: value.from, to: value.to } })
				}}
			/>
		</div>
		<div class="col-12 col-md-6">
			<YearInput
				id="{searchField.key}-to"
				label="To"
				disabled={disabled || inEditMode}
				value={value.to}
				change={newVal => {
					value.to = newVal
					change?.({ field: searchField, value: { from: value.from, to: value.to } })
				}}
			/>
		</div>
	</div>
</EditModeControls>
